import React, { useState } from "react";
import Select from "react-select";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useUpdateItem } from "../../_helper/actions/mutation/items";
import { toast } from "react-toastify";

const AllocateLocationModal = ({ isOpen, onClose, onSave, batch, item_id }) => {
  // Fetch item details (including location) using item_id.

  console.log(batch);
  const { data: getItem } = useItemsFilter(
    ApiEndPoint.INVENTORY,
    `?action=getItem&id=${item_id}&give_location=True`
  );

  const updateMutation = useUpdateItem(ApiEndPoint.PHARMACY);

  // Map the locations from getItem.location (if available) into react-select options.
  const locationOptions =
    getItem && getItem.location
      ? getItem.location.map((loc) => ({
          value: loc.box_id,
          label: loc.name,
        }))
      : [];

  const [selectedLocation, setSelectedLocation] = useState(null);

  const handleSave = () => {
    if (!selectedLocation) {
      toast.warning("Please select a location.");
      return;
    }

    console.log(selectedLocation);
    updateMutation.mutate(
      {
        data: {
          id: batch.id,
          action: "patchBatch",
          location: [selectedLocation.value],
        },
      },
      {
        onSuccess: () => {
          toast.success("Great! Batch Allocated");
          onClose();
        },
        onError: () => {
          toast.error("Opps! There is a issue in the allocation");
        },
      }
    );
    // onSave(selectedLocation);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <h3 className="text-xl font-semibold mb-4">Allocate Location</h3>
        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Select Location</label>
          <Select
            options={locationOptions}
            value={selectedLocation}
            onChange={(option) => setSelectedLocation(option)}
            placeholder="Select a location"
          />
        </div>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AllocateLocationModal;
